export const BEWERBUNG_PAGE = 'bewerbung';

export const UEBERSICHT_PAGE = 'bewerbung-uebersicht';
